export const CONTACT = {
  phone: "876-318-4376",
  phoneHref: "tel:+18763184376",
  whatsapp: "https://wa.me/18763184376",
  email: "anwillawja@gmail.com",
  emailHref: "mailto:anwillawja@gmail.com",
  addressLines: ["Shop 1, 7 Gully Road", "St. Ann's Bay, Jamaica"],
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Shop+1+7+Gully+Road+St+Anns+Bay+Jamaica",
};

export const IMAGES = {
  heroOffice:
    "https://images.unsplash.com/photo-1737926536433-c002eb06e3a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwbGF3JTIwb2ZmaWNlfGVufDB8fHx8MTc4NjMwNzk4NXww&ixlib=rb-4.1.0&q=85",
  family:
    "https://images.unsplash.com/photo-1648221350871-e3ae3c8d0f58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxmYW1pbHklMjBzdW5zZXR8ZW58MHx8fHwxNzg2MzA3OTg1fDA&ixlib=rb-4.1.0&q=85",
  realEstate:
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmUlMjBob3VzZXxlbnwwfHx8fDE3ODYzMDc5ODV8MA&ixlib=rb-4.1.0&q=85",
  signing:
    "https://images.unsplash.com/photo-1521791055366-0d553872125f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxzaWduaW5nJTIwZG9jdW1lbnR8ZW58MHx8fHwxNzg2MzA3OTg1fDA&ixlib=rb-4.1.0&q=85",
  principal: "/anique-portrait.webp",
  logo: "/annwil-logo.png",
  palm:
    "https://images.unsplash.com/photo-1525923838299-2312b60f6d69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHx0cm9waWNhbCUyMGxlYWZ8ZW58MHx8fHwxNzg2MzA3OTg1fDA&ixlib=rb-4.1.0&q=85",
};

export const PRACTICE_AREAS = [
  {
    id: "family-law",
    number: "01",
    title: "Family Law",
    short:
      "Guidance for family-related legal matters delivered with professionalism, discretion and sensitivity.",
    image: IMAGES.family,
    matters: [
      "Divorce and separation matters",
      "Child custody, access and maintenance",
      "Adoption applications",
      "Division of matrimonial property",
    ],
  },
  {
    id: "real-estate-law",
    number: "02",
    title: "Real Estate Law",
    short:
      "Legal assistance with matters relating to property, conveyancing and real estate transactions.",
    image: IMAGES.realEstate,
    matters: [
      "Sale and purchase agreements",
      "Conveyancing and transfers",
      "Title searches and registration",
      "Landlord and tenant matters",
    ],
  },
  {
    id: "probate",
    number: "03",
    title: "Probate",
    short:
      "Guidance through the legal processes involved in administering the estate of a deceased person.",
    image: IMAGES.signing,
    matters: [
      "Grants of probate and letters of administration",
      "Administration of estates",
      "Distribution of assets to beneficiaries",
      "Advice for executors and administrators",
    ],
  },
  {
    id: "estate-planning",
    number: "04",
    title: "Estate Planning",
    short:
      "Legal planning to help you organise important matters and make thoughtful arrangements for the future.",
    image: IMAGES.signing,
    matters: [
      "Preparation of wills",
      "Powers of attorney",
      "Estate and succession planning",
      "Guardianship and care arrangements",
    ],
  },
];

export const PROPERTY_FULL_SERVICE = [
  {
    icon: "search",
    title: "Property Sourcing",
    text: "We help you find the right property to purchase in Jamaica.",
  },
  {
    icon: "ruler",
    title: "Surveyor",
    text: "We commission the land surveyor to verify boundaries and measurements.",
  },
  {
    icon: "valuation",
    title: "Valuation",
    text: "We arrange an independent valuation so you know what the property is worth.",
  },
  {
    icon: "engineer",
    title: "Engineer's Report",
    text: "We coordinate a structural assessment of the property by an engineer.",
  },
  {
    icon: "trn",
    title: "TRN Registration",
    text: "We sort out your Taxpayer Registration Number for the transaction.",
  },
  {
    icon: "insurance",
    title: "Property Insurance",
    text: "We get the property insured, so your investment is protected from day one.",
  },
];

export const FAQ_CATEGORIES = [
  {
    number: "01",
    title: "Buying Property from Overseas",
    items: [
      {
        q: "Can I buy property in Jamaica without travelling there?",
        a: "Yes. Most of our clients complete their entire purchase from abroad. We manage the transaction on the ground in Jamaica and keep you updated at every stage — documents can be signed and notarised where you live, then sent to us for completion.",
      },
      {
        q: "I don't have a TRN. Can I still buy property?",
        a: "Yes. A Taxpayer Registration Number (TRN) is required for property transactions in Jamaica, but you don't need to arrange it yourself. Annwil Law Ja handles the TRN application process directly on your behalf as part of our full-service property purchase support.",
      },
      {
        q: "What does your full-service purchase support include?",
        a: "Everything between deciding to buy and collecting your keys: sourcing the property, commissioning the surveyor, arranging an independent valuation and an engineer's report, your TRN registration, property insurance — and the legal work from sale agreement through to registered title.",
      },
    ],
  },
  {
    number: "02",
    title: "Land Titling",
    items: [
      {
        q: "My family has owned land for generations, but there is no registered title. Can you help?",
        a: "Yes. This is very common in Jamaica. We guide you through the process of bringing inherited or unregistered land under the registered titles system, so ownership is properly recorded and protected.",
      },
      {
        q: "What paperwork do I need to get a title for family land?",
        a: "Start with whatever exists — old deeds, conveyances, wills, property tax receipts or certificates, and survey diagrams all help. We review what you have, identify the gaps, and advise on the clearest route to a registered title.",
      },
      {
        q: "Why does getting a registered title matter?",
        a: "A registered title makes your ownership clear and conclusive. It protects the land for future generations, prevents disputes, and makes it far easier to sell, transfer or use the property as security later on.",
      },
    ],
  },
  {
    number: "03",
    title: "Selling Inherited Homes",
    items: [
      {
        q: "Can I sell a home I inherited before the estate is settled?",
        a: "Generally, the estate must be administered first. If your loved one left a will, the executor applies for a grant of probate; if there was no will, a family member applies for letters of administration. Once granted, the property can be transferred and sold.",
      },
      {
        q: "What is the estate administration process?",
        a: "It involves locating the will (if any), applying to the Supreme Court for probate or letters of administration, gathering and valuing the estate's assets, settling debts, and then distributing or selling the property. We manage each step and keep you informed throughout.",
      },
      {
        q: "I live overseas. Can the sale be handled without me travelling to Jamaica?",
        a: "Yes. We routinely handle estate administration and property sales for beneficiaries abroad. Documents can be signed and notarised where you live, and we coordinate everything in Jamaica — including the sale itself — on your behalf.",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "As a client living overseas, trusting someone with my legal matters wasn't easy — but you earned my trust every step of the way. Your professionalism, honesty, and dedication went above and beyond my expectations. If you're looking for an amazing lawyer, I highly recommend her!",
    name: "A Client Living Overseas",
    location: "",
  },
];

export const VALUES = [
  {
    title: "Clarity",
    text: "Helping you understand your legal options.",
  },
  {
    title: "Professionalism",
    text: "Careful attention to each legal matter.",
  },
  {
    title: "Personal Attention",
    text: "A client-focused approach to legal service.",
  },
  {
    title: "Confidence",
    text: "Guidance that helps you make informed decisions.",
  },
];

export const DISCLAIMER =
  "The information on this website is provided for general informational purposes only and does not constitute legal advice. Contacting Annwil Law Ja through this website does not create an attorney-client relationship.";
